var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mb-lg-n4" },
    [
      _c("portal", { attrs: { to: "content-header" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "ci-collapsible-header",
                rawName: "v-ci-collapsible-header",
              },
            ],
            key: "podcasts-header",
            staticClass: "ci-content-header sticky",
            attrs: { id: "podcasts-header" },
          },
          [
            _c("div", { staticClass: "ci-content-header__inner" }, [
              _c("h1", {
                staticClass: "h2 header-title mb-0",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.views.contents.podcasts.title")
                  ),
                },
              }),
              _c("p", {
                staticClass: "header-teaser mt-2 mb-0",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("ui.views.contents.podcasts.teaser")
                  ),
                },
              }),
            ]),
          ]
        ),
      ]),
      _c("ContentsList", { attrs: { type: "podcasts" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }